import { render } from "./CumulativeProgressNew.vue?vue&type=template&id=466da991&ts=true"
import script from "./CumulativeProgressNew.vue?vue&type=script&lang=ts"
export * from "./CumulativeProgressNew.vue?vue&type=script&lang=ts"

import "./CumulativeProgressNew.vue?vue&type=style&index=0&id=466da991&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__